module.exports = __webpack_public_path__ + "img/blue.f1ced677.png";